var map = {
	"./en/default.json": [
		17653,
		7653
	],
	"./en/error.json": [
		44035,
		4035
	],
	"./en/home-policy.json": [
		88869,
		8869
	],
	"./vi/default.json": [
		58992,
		8992
	],
	"./vi/error.json": [
		25719,
		5719
	],
	"./vi/home-policy.json": [
		56675,
		6675
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 90492;
module.exports = webpackAsyncContext;